/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const GetCurrentUser = /* GraphQL */ `
  query GetCurrentUser($input: GetCurrentUserInput) {
    GetCurrentUser(input: $input)
  }
`;
export const SearchVehicle = /* GraphQL */ `
  query SearchVehicle($input: SearchVehicleInput) {
    SearchVehicle(input: $input)
  }
`;
export const ListViolations = /* GraphQL */ `
  query ListViolations {
    ListViolations
  }
`;
export const ListChats = /* GraphQL */ `
  query ListChats($input: ListChatsInput) {
    ListChats(input: $input)
  }
`;
export const ListMessages = /* GraphQL */ `
  query ListMessages($input: ListMessageInput) {
    ListMessages(input: $input) {
      items {
        chat_id
        message_text
        messaged_by_id
        messaged_by_user_details
        message_id
        messaged_on
        message_type
        message_sent_type
        has_reply_message
        no_of_replies
        replied_to_message_id
        replied_for_message_type
        replied_for_message_text
        reactions {
          chat_id
          reaction_id
          message_id
          reacted_time
          reacted_by_user_id
          reacted_by_user_first_name
          reacted_by_user_last_name
          reaction_type
          __typename
        }
        __typename
      }
      next_token
      __typename
    }
  }
`;
export const GetS3URL = /* GraphQL */ `
  query GetS3URL($key: String, $ContentType: String, $ContentLength: String) {
    GetS3URL(
      key: $key
      ContentType: $ContentType
      ContentLength: $ContentLength
    )
  }
`;
export const get_s3_file = /* GraphQL */ `
  query Get_s3_file($key: String) {
    get_s3_file(key: $key)
  }
`;
export const get_nearest_motorists = /* GraphQL */ `
  query Get_nearest_motorists($input: get_nearest_motorists_input) {
    get_nearest_motorists(input: $input)
  }
`;
export const view_car_details = /* GraphQL */ `
  query View_car_details($input: view_car_details_input) {
    view_car_details(input: $input)
  }
`;
export const viewProfilePic = /* GraphQL */ `
  query ViewProfilePic($input: viewProfilePicInput) {
    viewProfilePic(input: $input)
  }
`;
export const listMyActivities = /* GraphQL */ `
  query ListMyActivities($input: listMyActivitiesInput) {
    listMyActivities(input: $input)
  }
`;
